<template>
  <ElevatedCard
    :compact="compact"
    :variant="highlighted ? 'teal' : 'neutral'"
    :class="
      highlighted
        ? 'flex flex-col gap-2 border-lime-800/[.14]'
        : 'flex flex-col gap-2 border-gray-50'
    "
  >
    <div class="flex items-start justify-between gap-2">
      <span class="font-bold text-body-xl">{{ title }}</span>
      <span
        v-if="badge"
        class="bg-lime-200 text-lime-900 text-xs font-semibold px-3 py-1 rounded-full shrink-0"
        :class="highlighted && 'absolute top-0 right-3 -translate-y-1/2'"
      >
        {{ badge }}
      </span>
      <span v-if="price" class="font-bold text-body-xl shrink-0">
        {{ price }}
      </span>
    </div>
    <p class="text-sm text-gray-500">{{ description }}</p>
    <!--@slot The call to action rendered at the bottom of the card.-->
    <slot />
  </ElevatedCard>
</template>

<script setup lang="ts">
const { compact = false, highlighted = false } = defineProps<{
  title: string
  description: string
  badge?: string
  price?: string
  /** Tighter elevation, used for the stacked cards inside the buy box. */
  compact?: boolean
  /** Lead card: teal giftcard shadow, lime border, badge pinned to the top edge. */
  highlighted?: boolean
}>()
</script>
